module.exports = __webpack_public_path__ + "img/seating-theatre.d181e960.svg";